import React from 'react';
import { ButtonElement, ButtonElementProps } from './ButtonElement';

export type ExternalLinkButtonProps = ButtonElementProps & React.AnchorHTMLAttributes<HTMLAnchorElement>;

const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = (props) =>  {
    return <ButtonElement tag="a" {...props} />
}

export default ExternalLinkButton;